import { createAction } from '@reduxjs/toolkit';
import { notAvailable } from 'core/common/constants';
import { normalizeError } from 'core/common/errors';
import { SpanName } from 'core/common/observability/entities';
import { AppThunk } from 'core/common/store/types';

export const createAskNebulaAccountPending = createAction('auth/CREATE_ASKNEBULA_ACCOUNT/pending');
export const createAskNebulaAccountSucceed = createAction<string>(
  'auth/CREATE_ASKNEBULA_ACCOUNT/succeed',
);
export const createAskNebulaAccountFailed = createAction('auth/CREATE_ASKNEBULA_ACCOUNT/failed');

export const createAskNebulaAccountRequest = (): AppThunk => async (dispatch, _, context) => {
  const {
    loggingService: logger,
    authService,
    observabilitySystem,
    analyticsService,
    errorMonitoringService,
  } = context;

  const span = observabilitySystem.startSpan(SpanName.CREATE_ASKNEBULA_ACCOUNT);

  try {
    dispatch(createAskNebulaAccountPending());

    const result = await authService.getAskNebulaAuthenticationToken();

    dispatch(createAskNebulaAccountSucceed(result.authenticationToken));
    analyticsService.updateUserProperties({ user_id: result.accountId });

    span.succeed();
  } catch (e) {
    const err = normalizeError(e);
    logger.error(err);

    dispatch(createAskNebulaAccountFailed());

    errorMonitoringService.captureError(err, {
      tags: {
        get_params: location.search || notAvailable,
        error_message: err.message,
        error_reason: 'create_asknebula_account',
      },
    });

    span.fail(err);
  }
};
